export const UserModalStyles = {
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  avatarWrapper: {
    display: "flex",
    gap: "20px",
    width: "100%",
    alignItems: "center",
  },
  formFieldsWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    width: "100%",
  },
  formButtonsWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    gap: "20px",
    marginTop: 2,
  },
  avatarCardContent: {
    border: "1px solid #e0e0e0",
    borderRadius: 2,
    minWidth: "30%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
  },
};
